import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from './nav/AppDimensions.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  bodyBold2czwdzwknab0k as bodyBold,
  smallBody2trfy14zwtona as smallBody,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
} from '../theming/Titles.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../theming/colorManagement.mjs';
import { get_lightSection4cpu8okr0w14 as get_lightSection } from '../theming/sections.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function subTitleLabel(_this__u8e3s4, value, setup) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_AppDimensions().pg2_1);
  // Inline function 'com.crowpay.views.theming.subTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.jba(view_0.ob6_1.ybe(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp = view_0.tb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = value;
  }
  tmp.fbu(tmp_0);
  view.fbb(p_0, view_0);
  setup(view);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function field3(_this__u8e3s4, label, helperText, setup) {
  helperText = helperText === VOID ? null : helperText;
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_AppDimensions().ng2_1);
  bodyBold(view, label);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp$ret$0 = view.hbb(FieldSemantic_getInstance());
  view.jbb(tmp$ret$0, setup(view));
  if (!(helperText == null)) {
    smallBody(view, helperText);
  }
  _this__u8e3s4.fbb(p, view);
  return view;
}
function requiredField3(_this__u8e3s4, label, helperText, setup) {
  helperText = helperText === VOID ? null : helperText;
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_AppDimensions().ng2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  view_0.zb8(get_AppDimensions().pg2_1);
  var tmp = get_centered(view_0);
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.jba(view_1.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_0 = view_1.tb5_1;
  var tmp_1;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(label) === 0) {
    tmp_1 = '\xA0';
  } else {
    tmp_1 = label;
  }
  tmp_0.fbu(tmp_1);
  view_0.fbb(p_1, view_1);
  view_0.jbb(tmp, view_1);
  view_0.jbb(colored(view_0, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_0, '*'));
  view.fbb(p_0, view_0);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp$ret$11 = view.hbb(FieldSemantic_getInstance());
  view.jbb(tmp$ret$11, setup(view));
  if (!(helperText == null)) {
    smallBody(view, helperText);
  }
  _this__u8e3s4.fbb(p, view);
  return view;
}
function labeledSection(_this__u8e3s4, label, setup) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_AppDimensions().ng2_1);
  bodyBold(view, label);
  var tmp = get_lightSection(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  setup(view_0);
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function label2(_this__u8e3s4, label, helperText, setup) {
  helperText = helperText === VOID ? null : helperText;
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_AppDimensions().ng2_1);
  bodyBold(view, label);
  setup(view);
  if (!(helperText == null)) {
    smallBody(view, helperText);
  }
  _this__u8e3s4.fbb(p, view);
  return view;
}
function requiredLabel2(_this__u8e3s4, label, helperText, setup) {
  helperText = helperText === VOID ? null : helperText;
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_AppDimensions().ng2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  view_0.zb8(get_AppDimensions().pg2_1);
  view_0.jbb(get_centered(view_0), bodyBold(view_0, label));
  view_0.jbb(colored(view_0, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_0, '*'));
  view.fbb(p_0, view_0);
  setup(view);
  if (!(helperText == null)) {
    smallBody(view, helperText);
  }
  _this__u8e3s4.fbb(p, view);
  return view;
}
function requiredLabel(_this__u8e3s4, label, setup) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_AppDimensions().ng2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  view_0.zb8(get_AppDimensions().pg2_1);
  view_0.jbb(get_centered(view_0), bodyBold(view_0, label));
  view_0.jbb(colored(view_0, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_0, '*'));
  view.fbb(p_0, view_0);
  setup(view);
  _this__u8e3s4.fbb(p, view);
  return view;
}
//region block: exports
export {
  field3 as field321nct0g3w58o4,
  label2 as label287uhiq3m9m4z,
  labeledSection as labeledSection16775qn7m7foh,
  requiredField3 as requiredField31yu7ndxhpyxkd,
  requiredLabel2 as requiredLabel23q9lkacjaga4j,
  requiredLabel as requiredLabel1u8ua88lul448,
  subTitleLabel as subTitleLabel2tm7wvwblxr1h,
};
//endregion

//# sourceMappingURL=label2.mjs.map
